import { render } from "./accountSidebar.vue?vue&type=template&id=7fc6690b&scoped=true"
import script from "./accountSidebar.vue?vue&type=script&lang=js"
export * from "./accountSidebar.vue?vue&type=script&lang=js"

import "./accountSidebar.vue?vue&type=style&index=0&id=7fc6690b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc6690b"]])

export default __exports__